import { useStore } from "@/lib/states/store";

export const useWorkoutSession = () =>
  useStore((state) => state.workoutSession);

export const useActiveWorkout = () =>
  useStore((state) => state.workoutSession.activeWorkoutData);
